export default __webpack_public_path__ + "static/media/advertisers.a13ef116.png";